import { SVGProps, Ref, forwardRef } from 'react';

export const IndexGrayscaleSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 22.719c5.799 0 10.5-4.75 10.5-10.61S17.799 1.5 12 1.5 1.5 6.25 1.5 12.11 6.201 22.718 12 22.718"
                    stroke="#919191"
                    strokeWidth={1.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.5 8.926c.193 0 .35.159.35.354a.35.35 0 0 1-.35.354.35.35 0 0 1-.35-.354c0-.195.156-.354.35-.354"
                    stroke="#919191"
                    strokeWidth={1.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.5 8.926c.194 0 .35.159.35.354a.35.35 0 0 1-.35.354.35.35 0 0 1-.35-.354c0-.195.157-.354.35-.354"
                    stroke="#919191"
                    strokeWidth={1.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.645 14.939a6.3 6.3 0 0 1-5.647 3.54 6.3 6.3 0 0 1-5.646-3.54"
                    stroke="#919191"
                    strokeWidth={1.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
    </svg>
));
IndexGrayscaleSize24Glyph.displayName = 'IndexGrayscaleSize24Glyph';
